import React, { useEffect, useRef, useState } from "react";

const MONTHS_SHORT = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
const currentYear = new Date().getFullYear();
const YEARS = Array.from({ length: 30 }, (_, i) => currentYear + 5 - i);

const isYearMonth = (value) => /^\d{4}-\d{2}$/.test(value || "");

const parseValue = (value) => {
  if (!isYearMonth(value)) return null;
  const [year, month] = value.split("-").map(Number);
  return { year, month: month - 1 };
};

const styles = `
  .dtp-wrapper {
    position: relative;
    display: inline-block;
    font-family: 'DM Sans', system-ui, sans-serif;
  }

  .dtp-trigger {
    display: flex;
    align-items: center;
    gap: 6px;
    height: 32px;
    padding: 0 10px;
    border-radius: 4px;
    background: var(--dtp-bg, #f1f5f9);
    color: var(--dtp-text, #64748b);
    font-size: 12px;
    border: none;
    cursor: pointer;
    white-space: nowrap;
    transition: background 0.1s, color 0.1s;
  }
  .dtp-trigger:hover { background: #e2e8f0; }
  .dtp-trigger.active { background: #0369a1; color: #fff; }
  .dtp-trigger:disabled { opacity: 0.5; cursor: not-allowed; }

  .dtp-caret { font-size: 8px; transition: transform 0.2s ease; }
  .dtp-caret.open { transform: rotate(180deg); }

  .dtp-box {
    position: absolute;
    top: calc(100% + 5px);
    right: 0;
    z-index: 99999;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    width: 240px;
    box-shadow: 0 8px 24px -4px rgba(0,0,0,0.1), 0 2px 8px -2px rgba(0,0,0,0.06);
    overflow: hidden;
    animation: dtp-in 0.16s cubic-bezier(0.34, 1.3, 0.64, 1) both;
  }

  @keyframes dtp-in {
    from { opacity: 0; transform: translateY(-5px) scale(0.97); }
    to   { opacity: 1; transform: translateY(0) scale(1); }
  }

  .dtp-type-row {
    display: flex;
    gap: 4px;
    padding: 8px;
    border-bottom: 1px solid #e2e8f0;
    background: #f8fafc;
  }

  .dtp-type-btn {
    flex: 1;
    background: #fff;
    border: 1px solid #e2e8f0;
    color: #64748b;
    font-size: 11px;
    font-weight: 500;
    font-family: 'DM Sans', system-ui, sans-serif;
    cursor: pointer;
    padding: 6px 4px;
    border-radius: 6px;
    text-align: center;
    transition: background 0.1s, color 0.1s, border-color 0.1s;
  }
  .dtp-type-btn:hover { background: #fff4ea; color: #ff8820; }
  .dtp-type-btn.active {
    background: #ff8820;
    border-color: #ff8820;
    color: #fff;
    font-weight: 600;
  }

  .dtp-scroll {
    max-height: 260px;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #e2e8f0 transparent;
  }
  .dtp-scroll::-webkit-scrollbar { width: 3px; }
  .dtp-scroll::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 3px; }

  .dtp-year-item { border-bottom: 1px solid #e2e8f0; }
  .dtp-year-item:last-child { border-bottom: none; }

  .dtp-year-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background: none;
    border: none;
    text-align: left;
    font-size: 12px;
    font-family: 'DM Sans', system-ui, sans-serif;
    color: #0f172a;
    cursor: pointer;
    padding: 8px 14px;
    box-sizing: border-box;
    transition: background 0.1s;
  }
  .dtp-year-row:hover { background: #f8fafc; }
  .dtp-year-row.active { font-weight: 600; color: #ff8820; background: #fff4ea; }

  .dtp-year-chevron {
    font-size: 9px;
    color: #94a3b8;
    transition: transform 0.18s cubic-bezier(0.34,1.2,0.64,1);
  }
  .dtp-year-chevron.open { transform: rotate(90deg); color: #ff8820; }

  .dtp-months {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 2px;
    padding: 7px 10px 9px;
    background: #fdf8f3;
    border-top: 1px solid #e2e8f0;
    animation: dtp-slide-down 0.16s cubic-bezier(0.34,1.2,0.64,1) both;
  }

  @keyframes dtp-slide-down {
    from { opacity: 0; transform: translateY(-4px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  .dtp-mon-btn {
    background: none;
    border: 1px solid transparent;
    font-size: 11px;
    font-family: 'DM Sans', system-ui, sans-serif;
    color: #0f172a;
    cursor: pointer;
    padding: 5px 2px;
    text-align: center;
    border-radius: 6px;
    transition: background 0.1s, color 0.1s, transform 0.1s;
  }
  .dtp-mon-btn:hover { background: #fff4ea; color: #ff8820; transform: scale(1.07); }
  .dtp-mon-btn.active {
    background: #ff8820;
    color: #fff;
    font-weight: 600;
    box-shadow: 0 2px 5px rgba(255,136,32,0.35);
  }

  .dtp-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 10px 8px;
    border-top: 1px solid #e2e8f0;
  }
  .dtp-footer-btn {
    background: none;
    border: none;
    color: #ff8820;
    font-size: 11.5px;
    font-weight: 500;
    cursor: pointer;
    padding: 3px 6px;
    border-radius: 5px;
    font-family: 'DM Sans', system-ui, sans-serif;
    transition: background 0.1s;
  }
  .dtp-footer-btn:hover { background: #fff4ea; }
`;

export default function DateFilterPicker({
  type,
  month = "",
  onChange = () => null,
  options,
  disabled = false,
  className = "",
}) {
  const [open, setOpen] = useState(false);
  const parsed = parseValue(month);
  const [expandedYear, setExpandedYear] = useState(parsed?.year ?? currentYear);
  const wrapperRef = useRef(null);
  const scrollRef = useRef(null);

  const activeOption = options.find((o) => o.key === type) || options[0];

  useEffect(() => {
    if (parsed) setExpandedYear(parsed.year);
  }, [month]);

  useEffect(() => {
    if (open && scrollRef.current) {
      const active = scrollRef.current.querySelector(".active");
      if (active) active.scrollIntoView({ block: "center" });
    }
  }, [open]);

  useEffect(() => {
    const handleOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, []);

  const handleTypeSelect = (key) => {
    if (key === type) return;
    onChange({ type: key, month: "" });
  };

  const handleSelect = (year, monthIndex) => {
    const monthStr = String(monthIndex + 1).padStart(2, "0");
    onChange({ type, month: `${year}-${monthStr}` });
    setOpen(false);
  };

  const handleClear = () => {
    onChange({ type, month: "" });
    setOpen(false);
  };

  const label = parsed
    ? `${activeOption.label}: ${MONTHS_SHORT[parsed.month]} ${parsed.year}`
    : `${activeOption.label}: All`;

  return (
    <>
      <style>{styles}</style>
      <div ref={wrapperRef} className={`dtp-wrapper ${className}`}>
        <button
          type="button"
          className={`dtp-trigger${parsed ? " active" : ""}`}
          onClick={() => !disabled && setOpen((o) => !o)}
          disabled={disabled}
        >
          <span>{label}</span>
          <span className={`dtp-caret${open ? " open" : ""}`}>▼</span>
        </button>

        {open && (
          <div className="dtp-box">
            <div className="dtp-type-row">
              {options.map((o) => (
                <button
                  key={o.key}
                  type="button"
                  className={`dtp-type-btn${type === o.key ? " active" : ""}`}
                  onClick={() => handleTypeSelect(o.key)}
                >
                  {o.label}
                </button>
              ))}
            </div>
            <div className="dtp-scroll" ref={scrollRef}>
              {YEARS.map((y) => (
                <div className="dtp-year-item" key={y}>
                  <button
                    type="button"
                    className={`dtp-year-row${expandedYear === y ? " active" : ""}`}
                    onClick={() => setExpandedYear((prev) => (prev === y ? null : y))}
                  >
                    <span>{y}</span>
                    <span className={`dtp-year-chevron${expandedYear === y ? " open" : ""}`}>›</span>
                  </button>
                  {expandedYear === y && (
                    <div className="dtp-months">
                      {MONTHS_SHORT.map((m, i) => (
                        <button
                          key={m}
                          type="button"
                          className={`dtp-mon-btn${parsed?.year === y && parsed?.month === i ? " active" : ""}`}
                          onClick={() => handleSelect(y, i)}
                        >
                          {m}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div className="dtp-footer">
              <button className="dtp-footer-btn" onClick={handleClear} type="button">Clear</button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
